<template>
  <h2 class="pb-2 border-bottom">IM/IV & Vitamin Therapies</h2>
  <p>Energy, Balance, and Wellness from the Inside Out</p>
  <p>Our medically supervised IV therapies deliver hydration, nutrients, and antioxidants directly into your system for faster absorption and lasting benefits. Each treatment is designed to support your health, recovery, and well-being.”</p>
  <ul>
    <li>Wellness & Hydration — restore balance with electrolytes, vitamins, and antioxidants for full-body hydration.</li>
    <li>Energy & Performance — B12 and amino acids to boost energy, metabolism, and post-workout recovery.</li>
    <li>Skin & Rejuvenation (safe for Ads) — vitamin blends to support skin, hair, and natural glow.</li>
    <li>Metabolism & Weight Management — tailored infusions with amino acids and B vitamins for safe, supervised weight support.</li>
    <li>Recovery IV — rehydrate and rebalance after fatigue, travel, or stressful days.</li>
  </ul>
  <p>“Our IV therapies are personalized and supervised — designed to help you feel refreshed, re-energized, and balanced.”</p>
</template>

<script>
export default {
  name: 'IMIVVitaminTherapiesContentEn'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
